import { ChakraProvider as ChakraUIProvider } from '@chakra-ui/react';
import { system } from '@/theme';

interface ChakraProviderProps {
  children: React.ReactNode;
}

/**
 * Chakra UI v3 Provider with custom Digitane AI theme system
 */
export function ChakraProvider({ children }: ChakraProviderProps) {
  return <ChakraUIProvider value={system}>{children}</ChakraUIProvider>;
}
